/** Runs `fn` during browser idle time (falling back to a macrotask when unsupported or on the server). */
export function runOnIdle(fn: () => void, timeoutMs: number): void {
  if (typeof window === "undefined") return;
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(fn, { timeout: timeoutMs });
  } else {
    setTimeout(fn, 0);
  }
}
